/**
 * Created by calhosh on 7/20/2023
 */
import React, {useCallback} from 'react';
import styled from 'styled-components';
import {labels} from '../../../../util/utils';
import env from '../../../../util/env';

export default function OARNoRowsOverlay({engagementId, hasHelixProjects}) {
	let setupText = hasHelixProjects ? labels.OARNoDataAvailable.split('{0}') : labels.helixNotAvailable;

	const handleOnClickNavigate = useCallback(
		(event) => {
			event.preventDefault();
			window.open(env.getURL('hercules_web') + '/connections?engagementid=' + engagementId);
		},
		[engagementId]
	);

	return (
		<>
			{hasHelixProjects ? (
				<StyledOARNoRowsOverlay className="StyledOARNoRowsOverlay">
					<span className="helixSetURLText">{setupText[0]}</span>
					<span className="helixSetURL" onClick={handleOnClickNavigate}>
						{labels.helixSetup}
					</span>
					<span className="helixSetURLText">{setupText[1]}</span>
				</StyledOARNoRowsOverlay>
			) : (
				<StyledOARNoRowsOverlay className="StyledOARNoRowsOverlay">
					<span className="helixSetURLText">{setupText}</span>
				</StyledOARNoRowsOverlay>
			)}
		</>
	);
}

const StyledOARNoRowsOverlay = styled.section`
	font-size: var(--px-14);
	font-weight: 300;
	line-height: var(--px-22);
	color: var(--neutrals-700);
	.helixSetURL {
		font-weight: 700;
		color: var(--blue-600);
		cursor: pointer;
		pointer-events: all;
		&:hover {
			text-decoration: underline !important;
		}
	}
`;
